// extracted by mini-css-extract-plugin
export var actionButton = "_ky-0";
export var fileInput = "_ky-2";
export var paperclip = "_ky-1";